/**
 * Formata a mensagem de indisponibilidade com contagem de dias.
 * Os strings `from` e `to` devem vir no formato ISO curto: "YYYY-MM-DD".
 *
 * Regras:
 *  - Antes do início: "Indisponível de 13/05/2026 até 19/05/2026 (7 dias)"
 *    (N = dias totais inclusivos entre from e to)
 *  - Durante o período: "Indisponível de 13/05/2026 até 19/05/2026 (faltam 5 dias)"
 *    (M = dias restantes até `to`, inclusivos)
 *  - Após `to`: retorna `null` (não há mais indisponibilidade a mostrar)
 *  - Se faltarem parâmetros ou datas inválidas: retorna null
 */
export function formatUnavailabilityBadge(from, to) {
  if (!from || !to) return null;
  const fromDate = parseLocalDate(from);
  const toDate = parseLocalDate(to);
  if (!fromDate || !toDate) return null;

  const today = stripTime(new Date());

  if (today > toDate) return null;

  const fmt = (d) => d.toLocaleDateString('pt-BR');
  const msPerDay = 86400000;

  let count;
  let label;
  if (today < fromDate) {
    count = Math.round((toDate - fromDate) / msPerDay) + 1;
    label = count === 1 ? '1 dia' : `${count} dias`;
  } else {
    count = Math.round((toDate - today) / msPerDay) + 1;
    label = count === 1 ? 'falta 1 dia' : `faltam ${count} dias`;
  }
  return `Indisponível de ${fmt(fromDate)} até ${fmt(toDate)} (${label})`;
}

function parseLocalDate(s) {
  // "YYYY-MM-DD" → Date às 00:00 locais (sem timezone drift)
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

function stripTime(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
